import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PlantManagementLayoutComponent } from './layout/plant-management.layout';
import { TranslateModule } from '@ngx-translate/core';

const routes: Routes = [{ path: '', component: PlantManagementLayoutComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes), TranslateModule],
  exports: [RouterModule],
})
export class PlantManagementRoutingModule {}
